@let hasMBSPermission = 'MBS' | can: 'read';
@let hasRemoteManagementPermission = 'RemoteManagement' | can: 'read';
@let hasNotificationPermission = 'Notification' | can: 'read';
@let isRenewLicensesAllow = (permissionFlags | async)?.isRenewLicensesAllow;

@if (navLayout.isVertical()) {
  <mbs-side-nav />
}

<mbs-header></mbs-header>

<main class="mbs-container">
  <div
    class="mbs-container-inner"
    [class.mbs-inner-streight-content]="adaptivePage()">
    <div class="mbs-container-content">
      <router-outlet
        (activate)="handleActiveRoute($event)"
        (deactivate)="handleActiveRoute()"></router-outlet>
    </div>

    @if (isRenewLicensesAllow) {
      <mbs-auto-renewal-alert />
    }
    @if (hasMBSPermission) {
      @if (hasRemoteManagementPermission) {
        <mbs-unsupported-version />
      }
      <mbs-ub-notifications />
    }
    @if (hasNotificationPermission) {
      <mbs-email-service-status-component />
    }
    <mbs-unable-deliver-emails-alert></mbs-unable-deliver-emails-alert>
    <mbs-force-tfa-alert></mbs-force-tfa-alert>
    <mbs-toasts data-position="bottom-right"></mbs-toasts>
    <mbs-feedback-widget></mbs-feedback-widget>

    @if (showChat()) {
      @defer {
        <mbs-support-chat />
      }
    }

    @if (showFooter() && !navLayout.isVertical()) {
      <mbs-footer />
    }
  </div>
</main>

<ng-template #timezoneAlertTemplate>
  The default Provider Time Zone (UTC) is currently used to indicate the time.
  <mbs-button
    type="link"
    [isCtrl]="true"
    [size]="size.inherit"
    (click)="changeTimezoneClickHandler()">
    Change.
  </mbs-button>
</ng-template>

<ng-template #disconnectAlertTemplate>
  Connection lost.
  <mbs-button
    [isCtrl]="true"
    [size]="size.inherit"
    (click)="startSignalConnection()">
    Retry
  </mbs-button>
</ng-template>

<ng-template #freeRmmLicenseTemplate>
  <div [innerHTML]="'shared:modals.freeRmmLicenseText' | i18next"></div>
</ng-template>
